import api from '@/api'
import { sortBy } from 'lodash'

export default {
  namespaced: true,

  state: () => ({
    data: []
  }),

  actions: {
    get: async function (ctx, params) {
      const response = await api.get(`/v1/restaurants/${ctx.rootState.currentRestaurant.data._id}/sections`, params)

      ctx.commit('set', response.data)
    }
  },

  mutations: {
    set: function (state, sections) {
      const data = sections.map(section => ({ name: section.name, _id: section._id, id: section._id, uuid: section._id, area: section.area }))
      state.data = sortBy(data, 'name')
    },

    add: function (state, section) {
      const sections = [...state.data]

      sections.push(section)

      state.data = sortBy(sections, 'name')
    },

    update: function (state, section) {
      const sections = [...state.data]

      const sectionIndex = sections.findIndex(item => item._id === section._id)

      if (sectionIndex >= 0) {
        sections[sectionIndex] = section
      } else {
        sections.push(section)
      }

      state.data = sortBy(sections, 'name')
    },

    delete: function (state, section) {
      const sections = [...state.data]

      const sectionIndex = sections.findIndex(r => r._id === section._id)

      if (sectionIndex >= 0) {
        sections.splice(sectionIndex, 1)
      }

      state.data = sections
    },

    reset: function (state) {
      state.data = []
    }
  }
}
